import api from '@pray/shared/utils/api';

import type { BrandKitResponse } from './types';

export async function submitBrandKit({ artistId }: { artistId: string }): Promise<BrandKitResponse> {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/brand-kit/submit`;
  const response = await api.executePostRequest(url, {});

  return response.data.data;
}
